import merge from "ts-deepmerge";

/**
 * Merges objects together, including nested arrays (unless `mergeNestedArrays` is `false`).
 */
function mergeOrInsertObject<T extends { [key: string]: any }>(
  array: T[],
  value: T,
  find: (value: T, index: number) => boolean,
  mergeNestedArrays: boolean,
): T[] {
  const index = array.findIndex(find);

  if (index !== -1) {
    // Combines any nested arrays if desired
    const mergedObj = merge.withOptions(
      { mergeArrays: mergeNestedArrays ?? false },
      array[index],
      value,
    ) as T;
    return [...array.slice(0, index), mergedObj, ...array.slice(index + 1)];
  }

  return [...array, value];
}

export default mergeOrInsertObject;
